import { createStore } from 'vuex'

const myHeaders = {
  Authorization: "Bearer " + localStorage.getItem('token'),
};

export default createStore({
  state: {
    orderId:'',
    token:'',
    isSave:true,
    showMat:false,
    ableLeave:false,
    matType:'',

  },
  getters: {
  },
  mutations: {
    changeOrderId(state,payload) {
      state.orderId = payload;
    },
    changeMatType(state,payload) {
      state.matType = payload;
    },
    changeAbleLeave(state,payload) {
      state.ableLeave = payload;
    },

    changeIsSave(state,payload) {
      state.isSave = payload
    },
    changeShowMat(state,payload) {
      state.showMat = payload
    },
  },
  actions: {
  },
  modules: {
  }
})
